export const initialContent = {
  type: 'doc',
  content: [],
};
